export default "__VITE_ASSET__C$ix83f6__"